'use client'
import React, { useState, useEffect, useRef } from 'react'
// import { useSession } from 'next-auth/react'
import Image from 'next/image'
import Link from 'next/link'
import { AiOutlineLayout, AiFillHeart, AiOutlineHeart } from "react-icons/ai"
import { BiSolidBed, BiSolidBath } from "react-icons/bi"
import { FaMountain } from "react-icons/fa";
import { MdBeachAccess, MdPlaylistAddCheckCircle } from "react-icons/md";
import { FaWater } from "react-icons/fa";
import { IoMdVideocam } from 'react-icons/io'
import { BiArea, BiSolidArea } from "react-icons/bi";
import { FaBed, FaBath } from "react-icons/fa"
// import { sendLike } from '@services/sendLike'
import CurrencySymbol from '@components/CurrencySymbol'
import { MdVilla } from "react-icons/md";
import { FaBuilding } from "react-icons/fa";

import tailwindConfig from '@tailwind.config'
import LinkComponent from '@components/LinkComponent'
import { sendGAEvent } from '@next/third-parties/google'

const LargeProjectCard = ({ project, imageWidth = 300, imageHeight = 200, includeInactive = false, newLimit, isLast, district = undefined, newDevelopment = false, dictionary, lang }) => {
    const style = {
        color: tailwindConfig.theme.extend.colors.secondary,
        height: 90,
        overflow: 'hidden',
        z: 10
    };

    // const [showLikeBtn, setShowLikeBtn] = useState(false)
    // const [isLiked, setIsLiked] = useState(property.isLiked)
    // const { data: session } = useSession()

    const cardRef = useRef();

    // const handleLike = async () => {
    //     const isLike = await sendLike(property.id)
    //     setIsLiked((prevLike) => !prevLike)
    //     property.isLiked = !property.isLiked
    // };

    useEffect(() => {
        if (!cardRef?.current) return;

        const observer = new IntersectionObserver(([entry]) => {
            if (isLast && entry.isIntersecting) {
                newLimit();
                observer.unobserve(entry.target);
            }
        });

        observer.observe(cardRef.current);
    }, [isLast]);

    // useEffect(() => {
    //     if (session !== null) {
    //         setShowLikeBtn(true)
    //     }
    // }, [])

    // let location = 'Pattaya'

    // switch (lang) {
    //     case 'en':
    //         location = 'Pattaya'
    //         break;
    //     case 'th':
    //         location = 'พัทยา'
    //         break;
    //     case 'cn':
    //         location = '芭提雅'
    //         break;
    //     default:
    //         location = 'Pattaya'
    //         break;
    // }

    // const isSmallDevice = window.innerWidth < 768;
    // const isTablet = window.innerWidth < 1024;

    return (
        <div 
            ref={cardRef} 
            className={`relative sm:w-[${imageWidth}px] w-full`}
            onClick={() => sendGAEvent({ 
                event: "select_project",
                project_id: project.id,
                project_name: project.name,
                project_type: project.newDevelopment ? 'new_development' : 'project',
                project_location: project.districts[0]?.subdistrictName?.['en'],
            })} 
        >
            {/* {(isLiked == false) && (
                <div title="Left-click on this icon to save this property" onClick={handleLike} className='absolute flex flex-row flex-wrap top-1 right-1 z-40 h-8 w-8 justify-center items-center border-[1px] border-secondary rounded-md p-1'>
                    <AiOutlineHeart
                        size={24}
                        color={tailwindConfig.theme.extend.colors.secondary}
                    />
                </div>
            )}
            {(isLiked == true) && (
                <div title="Left-click to unlike this property" onClick={handleLike} className='absolute flex flex-row flex-wrap top-1 right-1 z-40 h-8 w-8 justify-center items-center border-[1px] border-third rounded-md p-1'>
                    <AiFillHeart
                        size={24}
                        color={tailwindConfig.theme.extend.colors.third}
                    />
                </div>
            )} */}
            <LinkComponent
                href={`/${newDevelopment ? 'new-developments' : 'projects'}/` + project.slug}
            >
                <div>
                    <div className='relative'>
                        <Image
                            placeholder="blur"
                            blurDataURL={project.blur}
                            className='sm:w-[300px] w-full object-cover aspect-[4/3] rounded-md overflow-hidden'
                            src={project.cover ? project.cover : '/images/placeholder.jpg'}
                            width={imageWidth}
                            height={imageHeight}
                            alt={project.slug}
                        />
                        {project.isPromotion ? (
                            <div className='absolute top-2 bg-third text-light p-1 rounded-r-md z-10 font-semibold'>{project.promotionTitle}</div>
                        ) : null
                        }
                    </div>
                    <div className='text-maincolor px-2 text-xl font-semibold rounded-r-md z-10 sm:w-[300px] w-full overflow-hidden'><h3>{project.name}</h3></div>
                        {project.fromPrice !== undefined && (
                            <div className='text-xl font-semibold text-third'>{dictionary.from}<CurrencySymbol />{project.fromPrice}{dictionary.from2}</div>
                        )}
                        {project.category == 'House' ? (
                            <div className='flex flex-row items-center px-2 mr-2'>
                                <MdVilla
                                    color={tailwindConfig.theme.extend.colors.secondary}
                                />
                                <span className='ml-1 text-maincolor'>{dictionary.house}</span>
                            </div>
                        ) : (
                            <div className='flex flex-row items-center px-2 mr-2'>
                                <FaBuilding
                                    color={tailwindConfig.theme.extend.colors.secondary}
                                />
                                <span className='ml-1 text-maincolor'>{dictionary.condo}</span>
                            </div>
                        )}

                        <div className='px-2 pb-2'>
                            <p className='text-mainhover'>{project?.districts[0]?.subdistrict}, {project?.districts[0]?.location}</p>
                        </div>
                    </div>
            </LinkComponent >
        </div>
    )
}

export default LargeProjectCard